// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sw_a bhj_b bhj_bj","SubscribedPhotoblogs__link":"sw_b bhj_a bhj_r"};